<template>
    <TMobileItems
        v-model="sortingValue"
        :footer-button-text="footerButtonText"
        :sorting-buttons="sortingPanelButtons"
        :active-buttons="indexPanelActiveButtons"
        :current-letter-index-panel="currentLetterIndexPanel"
        :index-panel="!isLandscape"
        :theme="'back'"
        sorting-panel
        color="#157251"
        class="o-mobile-care mobile-care"
        @onFooterButton="handleClickBack"
        @clickLetter="handleClickLetter"
    >
        <template #header>
            <AMHeaderItems
                :title="$t('ui.care-category')"
                :subtitle="$t('ui.care-category.description')"
                color="#157251"
                right-slot
                @onClose="handleClose"
            >
                <template #left>
                    <AMBackButton
                        v-if="isLandscape"
                        theme="back"
                        :text="$t('ui.back')"
                        @onClick="handleClickBack"
                    />
                    <svg-icon
                        v-else
                        original
                        name="icons/mobile_items_care"
                        class="mobile-services__care-icon"
                    />
                </template>
                <template #right>
                    <AMItemsCloseButton
                        v-if="!isLandscape && isCloseButtonShow"
                        @onClick="handleClickBack"
                    />
                    <AMBackButton
                        v-if="isLandscape"
                        theme="close"
                        :text="$t('ui.close')"
                        @onClick="handleClickBack"
                    />
                </template>
            </AMHeaderItems>
        </template>
        <template #container>
            <RecycleScroller
                ref="tilesList"
                #default="{ item }"
                :items="items"
                :item-size="isLandscape ? 40 : 97"
                class="mobile-care__scroller"
                :class="{'mobile-care__scroller--landing': !isLandscape}"
                emitUpdate
                @update="highlightActiveLetter"
            >
                <OWItemTile
                    :item="item"
                    @onClick="handleTileClick"
                />
            </RecycleScroller>
        </template>
    </TMobileItems>
</template>

<script>
import { 
    mapState, 
    mapGetters  
} from 'vuex';
import uniq from "lodash/uniq";

import OWItemTile from '../../organisms/o-w-item-tile/o-w-item-tile';
import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import TMobileItems from '../../templates/t-mobile-items/t-mobile-items';
import AMHeaderItems from '../../atoms/a-m-header-items/a-m-header-items';
import AMItemsCloseButton from '../../atoms/a-m-items-close-button/a-m-items-close-button';

import { GUIDE_NEW_POINT } from "../../../utils/constants/bus-events-constants";
import {
    MOBILE_ROOT,
    MOBILE_CARE,
    MOBILE_GUIDE
} from '../../../utils/constants/pages'

export default {
    name: 'OMobileCare',
    components: {
        OWItemTile,
        AMBackButton,
        TMobileItems,
        AMHeaderItems,
        AMItemsCloseButton
    },
    data() {
        return {
            sortingValue: 'All',
            currentLetterIndexPanel: 'a',
            scrollerItemsNumber: 0 // This variable shows us how many items be in RecycleScroller
        }
    },
    props: {
        /**
         * Use in case we need to exclude some item from tenants list.
         * For example: items on searchbar on guide screen
         */
        filteredByItem: {
            type: Number,
            default: null
        },
        isCloseButtonShow: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape
        }),
        ...mapGetters([
            't',
            'getTenantsAZ'
        ]),
        /**
         * Filtered tenants by item (if provided) and by sorting value set in sorting panel (if sorting value provided)
         * @returns {object|Array}
         */
        items() {
            const t = this.t;
            const tenants = this.getTenantsAZ;
            const filteredTenantsByItem = this.filteredByItem ? tenants.filter(item => item.id !== this.filteredByItem) : tenants;

            if (this.sortingValue && this.sortingValue !== 'All') {
                const valueLength = this.sortingValue.length;
                const selectedItems = [];
                for (let i = 0; i < valueLength; i++) {
                    selectedItems.push(...filteredTenantsByItem.filter((name) => {
                        const firstLetter = t(name, "name").charAt(0);
                        return firstLetter === this.sortingValue.charAt(i);
                    }));
                }
                return selectedItems;
            }
            return tenants;
        },
        /**
         * Detects what letters will render in sorting panel
         * @returns {object|Array}
         */
        sortingPanelButtons() {
            return uniq(this.getTenantsAZ.map((item) => {
                return this.t(item, "name").charAt(0);
            }));
        },
        footerButtonText() {
            return this.$route.name === MOBILE_CARE ? this.$t('ui.close') : this.$t('ui.back')
        },
        /**
         * Detects active letters for index panel
         * * @returns {object|Array}
         */
        indexPanelActiveButtons() {
            return uniq(this.items.map((item) => {
                return this.t(item, "name").charAt(0).toLowerCase();
            }));
        }
    },
    mounted() {
        this.scrollerItemsNumber = Math.ceil( document.querySelector('.mobile-care__scroller').clientHeight / (this.isLandscape ? 40 : 97)) + 5;
        this.currentLetterIndexPanel = this.t(this.items[0], 'name').charAt(0).toLowerCase();
    },
    watch: {
        isLandscape(value) {
            if (!value) this.sortingValue = 'All'
        }
    },
    methods: {
        handleClickBack() {
            if (this.$route.name === MOBILE_CARE) this.redirectToHome();
            else this.emitClickBack();
        },
        redirectToHome() {
            const params = {
                name: MOBILE_ROOT
            };
            this.$router.push(params);
        },
        handleTileClick(data) {
            switch(this.$route.name) {
            case MOBILE_CARE:
                this.redirectToGuide(data);
                break;
            case MOBILE_GUIDE:
                this.changeExtremePoint(data);
                break;
            default: 
                break;
                    
            }
        },
        emitClickBack() {
            this.$emit('onClickBack', true);
        },
        redirectToGuide(data) {
            const params = {
                name: MOBILE_GUIDE,
                params: {
                    type: 'care'
                },
                query: {
                    to: data.id
                }
            };
            this.$router.push(params);
        },
        changeExtremePoint(data) {
            this.$bus.$emit(GUIDE_NEW_POINT, data.id);
            this.$emit('changeExtremePoint');
        },
        highlightActiveLetter(start, end) {
            const item = this.items[start + 3];
            if(end < this.items.length && end > this.scrollerItemsNumber) 
                this.currentLetterIndexPanel = this.t(item, 'name').charAt(0).toLowerCase();
        },
        handleClickLetter(letter) {
            const itemIndex = this.items.findIndex( i  => this.t(i,'name',' ').charAt(0).toLowerCase() === letter);
            if(itemIndex !== -1) this.$refs.tilesList.scrollToItem(itemIndex);
        },
        handleClose() {
            this.emitClickBack()
        }
    }
}
</script>

<style lang="scss">
@import "o-mobile-care";
</style>